import { render, staticRenderFns } from "./Home_Visa_Item.vue?vue&type=template&id=d4b62ef4&scoped=true&"
import script from "./Home_Visa_Item.vue?vue&type=script&lang=js&"
export * from "./Home_Visa_Item.vue?vue&type=script&lang=js&"
import style0 from "./Home_Visa_Item.vue?vue&type=style&index=0&id=d4b62ef4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4b62ef4",
  null
  
)

export default component.exports